module.exports = __webpack_public_path__ + "static/media/slider-right-icon.5c2b7da5.svg";